// idle.service.ts
import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, timer, Subscription } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import {AuthService} from "./auth_service";
import {HttpResponse} from "@angular/common/http";
import {Router} from "@angular/router";
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class IdleService {

    private idleTimeout = environment.idleTimeout * 60 * 1000;
    private lastActivity = Date.now();
    private timer: any;

    private userActivityEvents = ['mousemove', 'keydown', 'scroll', 'click'];
    private idleSubscription: Subscription | null = null;

    constructor(private ngZone: NgZone, private authService :AuthService,
    private router: Router) {}

    startWatching(onTimeout: (start:number) => void) {

        if (!environment.production) {
            console.log(environment.idleTimeout);

        }
        this.timer = setInterval(() => {
            const delta = this.getDelta();
            if (delta > this.idleTimeout) {
                this.ngZone.run(() => onTimeout(delta - this.idleTimeout));
            }
            if (!environment.production) {
                console.log('delta:' + delta + " - timeout:" + this.idleTimeout);
            }

        }, 5000);

        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        document.addEventListener('focus', this.handleFocus);

        if (this.idleSubscription) {
            //console.warn('[IdleService] Già in ascolto. Ignoro nuova startWatching().');
            return;
        }

        this.ngZone.runOutsideAngular(() => {
            const activityEvents$ = merge(
                ...this.userActivityEvents.map(event => fromEvent(document, event))
            );

            this.idleSubscription = activityEvents$.pipe(
                tap(() => {
                    const now = Date.now();
                    if (Date.now() > this.lastActivity) {
                        this.lastActivity = now + 3000;
                        localStorage.setItem('lastActivity', now.toString());
                    }
                }),
                switchMap(() => timer(this.idleTimeout))
            ).subscribe();
        });
    }

    getDelta() {
        return Date.now() - this.lastActivity;
    }

    stopWatching() {
        if (this.idleSubscription) {
            this.idleSubscription.unsubscribe();
            this.idleSubscription = null;
        }
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    private handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            if (this.getDelta() > this.idleTimeout + 60*1000) {
                // this.ngZone.run(() => this.timeoutCallback());
                if (!environment.production) {
                    console.log('Service idle timeout (visibility)');
                }

                //this.stopWatching();
                this.logout("visibility", this.lastActivity, Date.now().toString(), this.idleTimeout);
            }
        }
    }

    private handleFocus = () => {
            const last = parseInt(localStorage.getItem('lastActivity') || '0', 10);
            const now = Date.now();
            const diff = now - last;

            if (this.getDelta() > this.idleTimeout + 60*1000) {
                // this.ngZone.run(() => this.timeoutCallback());

                if (!environment.production) {
                    console.log('Service idle timeout (focus)');
                }

                //this.stopWatching();
                this.logout("focus", this.lastActivity, Date.now().toString(), this.idleTimeout);
            }

    }

    logout(prefix: any, last: any, now: any, idleTimeout: any) {
        var log = "[" + prefix + "] last: " + last + ", now: " + now + ", idleTimeout: " + idleTimeout
        this.authService.logout(log).subscribe({
            next: (response:HttpResponse<any>) => {
                this.router.navigate(['/login']);
            },
            error: (error) => {}
        })
    }
}
